var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table',{ref:"table",staticClass:"display user-datatable nowrap",staticStyle:{"width":"100%"}},[_c('thead',[_c('tr',_vm._l((_vm.columns),function(column,index){return _c('th',{domProps:{"innerHTML":_vm._s(column.name)}})}),0)])])}
var staticRenderFns = []

export { render, staticRenderFns }